import * as moment from 'moment';
export class LogsData {

 public countryCode?: string;
 public createdDate?: moment.Moment;
 public duration?: Duration[];
 public id?: number;
 public jobEndDate?: string;
 public jobName?: string;
 public jobStartDate?: string;
 public jobStatus?: string;
 public jobType?: string;
 public notEligibleRecords?: string;
 public recordsProcessed?: number;
 public updatedDate?: string;

    static fromDto(r) {
      if (!r) {
        return null;
      }
        const logsData           = new LogsData();
        logsData.countryCode = r?.country_code;
        logsData.createdDate = moment(r?.created_date);
        logsData.duration = r?.duration;
        logsData.id = r?.id;
        logsData.jobEndDate = r?.job_end_date;
        logsData.jobName = r?.job_name;
        logsData.jobStartDate = r?.job_start_date;
        logsData.jobStatus = r?.job_status;
        logsData.jobType = r?.job_type;
        logsData.notEligibleRecords = r?.not_eligible_records;
        logsData.recordsProcessed = r?.records_proccessed;
        logsData.updatedDate = r?.updated_date;

        return logsData;
      }

      static toDto(r: LogsData): any {
        if (!r) {
          return null;
        }

        return {
          country_code: r.countryCode,
          created_date: r.createdDate,
          duration: r.duration,
          id: r.id,
          job_end_date: r.jobEndDate,
          job_name: r.jobName,
          job_start_date: r.jobStartDate,
          job_status: r.jobStatus,
          job_type: r.jobType,
          not_eligible_records: r.notEligibleRecords,
          records_proccessed: r.recordsProcessed,
          updated_date: r.updatedDate
        };
      }
}




export class Duration {
    date: number;
    day: number;
    hours: number;
    minutes: number;
    month: number;
    seconds: number;
    time: number;
    timezoneOffset: number;
    year: number;
  }
